import { MAIN_IMAGE_ROOT } from 'app_config';
import { ImageComponent } from 'components';
import { renderDate } from 'helpers/timeHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface OwnProps {
  technicianSignatureUrl?: string | null;
  companyStampUrl?: string | null;
  withDate?: boolean;
  withName?: boolean;
  customDate?: string;
  technicianName?: string;
  realStart: string;
  customName?: string;
  customTitle?: string;
  hideStamp?: boolean;
}

const TechnicianSignatureBlock = (props: OwnProps) => {
  const {
    technicianSignatureUrl,
    withDate,
    withName,
    customDate,
    technicianName,
    realStart,
    companyStampUrl,
    customName,
    customTitle,
    hideStamp
  } = props;

  const { t, i18n } = useCustomTranslation();

  // const [imageHeight, setImageHeight] = useState<number | null>(null);

  // const getMeta = (url: string): Promise<{ height: number; width: number }> => {
  //   return new Promise((resolve, reject) => {
  //     let img = new Image();
  //     img.onload = () => resolve({ height: img.height, width: img.width });
  //     img.onerror = reject;
  //     img.src = url;
  //   });
  // };

  // const getDimensions = async () => {
  //   const url = companyStampUrl
  //     ? `${MAIN_IMAGE_ROOT}${companyStampUrl}`
  //     : `${MAIN_IMAGE_ROOT}${technicianSignatureUrl}`;

  //   const result = await getMeta(url);
  //   setImageHeight(result.height);
  // };

  // useEffect(() => {
  //   // eslint-disable-next-line @typescript-eslint/no-floating-promises
  //   getDimensions();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  return (
    <div className="TechnicianSignatureBlock">
      {technicianSignatureUrl && (
        <div className="content">
          <div className="heading">
            {customTitle || t('customData.signature.technicianSignature')}
          </div>
          <div
            className="images_wrapper"
            // style={{ height: imageHeight || undefined }}
          >
            {!hideStamp && companyStampUrl && (
              <ImageComponent url={`${MAIN_IMAGE_ROOT}${companyStampUrl}`} className="stamp" />
            )}
            <ImageComponent
              url={`${MAIN_IMAGE_ROOT}${technicianSignatureUrl}`}
              className="signature"
            />
          </div>
          <div>
            {withDate && (
              <div className="date">
                {customDate
                  ? renderDate(customDate, 'LL', i18n.language)
                  : renderDate(realStart, 'LL', i18n.language)}
              </div>
            )}
            {withName && <div className="name">{customName || technicianName || ''}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default TechnicianSignatureBlock;
